import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConstantService {

  geoLocation = {
    latitude: 'latitude',
    longitude: 'longitude',
    country: 'country',
    state_Prov: 'state_prov',
    district: 'district',
    city: 'city',
    zipcode: 'zipcode',
    ip: 'ip',
    isp: 'isp',
    imgType: 'jpg',
    imgType2: 'jpg',
    imgType3: '',
    makerId: 'makerId',
    holderPriority: 1,
    imgProof1: 'imgProof1',
    imgProof2: '',
    imgProof3: '',
    imgIndex: 0,
  };


  keyValue = '842a357c4b385726090aa184b75b691075da95e6ddd4eb40'; //-- For Crpto
  clientInfoKey = 'kahdAjhfdsd423jkoi3frDFD3vbxvzyXZ4S4dF';
  ivValue = '53471a3a3623160b53471a3a3623160b'; // for Cropto
  appSource = localStorage.getItem('appSource');
  companyID = '2';
  businessID: any = '1';
  userType = 'Client'
  checksumDateFormate = 'ddMMyy';
  snackBarDuration = 5000;
  menuCacheValidity = 86400000;
  appName = 'WEB';

  reqHead = {
      "appVer": "1.0",
      "appName": "5P",
      "osName": "WEB",
      "key": "kahdAjhfdsd423jkoi3frDFD3vbxvzyXZ4S4dF"
  }

  localStorageElement = {
      inputClientCode: 'inputClientCode',
      clientCode: 'clientCode',
      clientStatus: 'clientStatus',
      loginVia: 'loginVia',
      sessionId: 'sessionId',
      userFirstName: 'userFirstName',
      userEmailId: 'userEmailId',
      userName: 'userName',
      userMobile: 'userMobile',
      jwt: 'jwt',
      returnUrl: 'returnUrl',
      _5PaisaCookie: '_5PaisaCookie',
      currentStageId: 'CurrentStageId',
      isDigiSkip: 'isDigiSkip',
      panFullName: 'panFullName',
      eAccountTokenChecksum: 'eAccountTokenChecksum',
      panNo: 'panNo',
      dob: 'dob',
      kycSource: 'kycSource',
      digilockerData: 'digilockerData',
      onScreenId: 'OnScreenId',
      patnerDetails: 'patnersDetails',
      footerMenu: 'footerMenu',
      userMenu: 'userMenu',
      mobileVerified: 'MobileVerified',
      emailVerified: 'EmailVerified',
      product: 'Equity',
      CheckNationality: 'CheckNationality',
      CheckDeclaration: 'CheckDeclaration',
      FirstName: 'FirstName',
      MiddleName: 'MiddleName',
      LastName: 'LastName',
      menuDataSyncTime: 'menuDataSyncTime',
      chartToken: 'chartToken',
      selfieBytes: 'selfieBytes',
      notificationFeedLength: 'notificationFeedLength',
      ipoToken: 'IpoToken',
      IsPANOrderID: 'IsPANOrderID',
      attempts: 'attempts',
      totalAttempts: 'totalAttempts',
      derivatives: 'derivatives',
      ip: 'ip',
      activationToken: 'activationToken',
      subSource: 'SubSource',
      appSource: 'appSource',
      isKRAGender: 'isKRAGender'
  };

  proofStatus = {
      U: 'U',
      A: 'A',
      R: 'R',
      N: 'N',
      Y: 'Y',
      P: 'P'
  };
}

export enum APICallingLimit {
  zero_0 = 0,
  one_1 = 1,
  two_2 = 2,
  three_3 = 3,
  four_4 = 4
}

export enum SessionStorage {
  authorization = 'authorization',
  authenticationkey = 'authenticationkey',
  authorization_KYC = 'authorization_KYC',
  authenticationkey_KYC = 'authenticationkey_KYC',
  authorization_Modi = 'authorization_Modi',
  
  subSource = 'subSource',
  appSource = 'appSource',
  clientCode = 'clientCode',
  userMobile = 'userMobile',
  userEmail = 'userEmail',
  ip = 'ip',
  stageId = 'stageId',
  isSkipDigi = 'isSkipDigi',
  isSkipKRAdigi = 'isSkipKRAdigi',
  hyperVergeIP = 'hyperVergeIP',
  selfieBytes = 'selfieBytes',
  userName = 'userName',
  isDigi = 'isDigi',
  progress = 'progress',
  subStageId = 'subStageId',
  returnURL = 'returnURL',
  device = 'device'
}

export enum ClientDetails {
  add1 = '',
  add2 = '',
  add3 = '',
  pincode = '',
  city = '',
  state = '',
  country = '',
  transferAmount = '1',
  transferType = 'IMPS',
  fName = 'FName',
  mName = 'MName',
  lName = 'LName',
  bankID = '0',
  photoProofUploaded = 'photoProofUploaded',
  photoProofStatus = 'photoProofStatus',
  photoRejReason = 'photoRejReason',
  signatureProofUploaded = 'signatureProofUploaded',
  signatureProofStatus = 'signatureProofStatus',
  signatureRejReason = 'signatureRejReason',
  panProofStatus = 'panProofStatus',
  panCardProofUploaded = 'panCardProofUploaded',
  panCardRejReason = 'panCardRejReason',
  panRejReason = 'panRejReason',
  bankProofStatus = 'bankProofStatus',
  bankProofUploaded = 'bankProofUploaded',
  bankRejReason = 'bankRejReason',
  addressProofStatus = 'addressProofStatus',
  addressProofUploaded = 'addressProofUploaded',
  addressRejReason = 'addressRejReason',
  incomeProofStatus = 'incomeProofStatus',
  incomeProofUploaded = 'incomeProofUploaded',
  incomeRejReason = 'incomeRejReason',
  permanentAddressProofUploaded = 'permanentAddressProofUploaded',
  permanentAddressProofStatus = 'permanentAddressProofStatus',
  financeProofUploaded = 'financeProofUploaded',
  financeProofStatus = 'financeProofStatus',
  panCardProofStatus = 'panCardProofStatus',
  derivatives = 'derivatives',
  kycStatus = 'kycStatus',
  oldKycStatus = 'oldKycStatus',
  kYCSource = 'kYCSource',
  aadhaarProofCode = 'aadhaarProofCode',
  proofTypeDetails = 'proofTypeDetails',
  correspondenceAddressProofUploaded = 'correspondenceAddressProofUploaded',
  correspondenceAddressProofStatus = 'correspondenceAddressProofStatus',
  addressBytes1 = 'addressBytes1',
  addressBytes2 = 'addressBytes2',
  bankBytes = 'bankBytes',
  incomeBytes1 = 'incomeBytes1',
  incomeBytes2 = 'incomeBytes2',
  panBytes = 'panBytes',
  signatureBytes = 'signatureBytes',
  permanentAddressBytes1 = 'permanentAddressBytes1',
  permanentAddressBytes2 = 'permanentAddressBytes2',
  eAccountTokenChecksum = 'eAccountTokenChecksum',
  ClientCode = 'clientCode',
  ClientStatus = 'ClientStatus',
  MobileNumber = 'userMobile',
  EmailId = 'EmailId',
  PanFirstName = 'PanFirstName',
  PanLastName = 'PanLastName',
  PanMiddleName = 'PanMiddleName',
  checkPanAadharSeeding = 'checkPanAadharSeeding',
};

export enum IndexValue {
  user = 0,
  pass = 1,
  Auth = 2,
  checkSum = 3
};

export enum DateFormate {
  ddMMyy = 'ddMMyy',
}

export enum LocalStorage {
  appSource = 'appSource',
  subSource = 'subSource',
  clientCode = 'clientCode',
  userMobile = 'userMobile',
  ip = 'ip',
}